import { useEffect, useState } from "react";

interface LoomPlayerProps {
  videoId: string;
  className?: string;
}

const LoomPlayer = ({ videoId, className = "" }: LoomPlayerProps) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Load Loom embed script
    const script = document.createElement("script");
    script.src = "https://www.loom.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className={`w-full aspect-video relative bg-gray-100 ${className}`}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1059E6]"></div>
            <p className="mt-2 text-sm text-gray-600">Video wird geladen...</p>
          </div>
        </div>
      )}
      <iframe
        src={`https://www.loom.com/embed/${videoId}`}
        frameBorder="0"
        allowFullScreen
        className="w-full h-full"
        onLoad={() => setIsLoading(false)}
        title="Loom video player"
      />
    </div>
  );
};

export default LoomPlayer; 